// extracted by mini-css-extract-plugin
export var icon = "copy-module--icon--sSejk";
export var inputPrefix = "copy-module--inputPrefix--gp5qh";